const formatAsString = (value) => {
    if (value === undefined)
        return undefined;
    if (typeof value === "string")
        return value;
    return value.join("\n");
};
export default formatAsString;
